import { useEffect, useState, useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  createProductItem,
  createProductType,
  deleteProduct,
  deleteProductType,
  getAllProductType,
  getAllProducts,
  getDiscountProducts,
  getFees,
  toggleFreeDelivery,
  getProduct,
  updateProductType,
  updateSingleProduct,
} from "../../redux/thunk";
import toast from "react-hot-toast";
import { FaUpload } from "react-icons/fa";
import LoadingSpinner from "../../components/elements/LoadingSpinner";
import ServiceModal from "../../components/modals/ServiceModal";
import AddCategoryModal from "../../components/modals/AddCategoryModal";
import UpdateCategoryModal from "../../components/modals/UpdateCategoryModal";
import { Preloader } from "../../components/elements/Preloader";
import Pagination from "../../components/Pagination";
import axios from "axios";
import { IoFilterOutline } from "react-icons/io5";
import { products } from "../../types/types";
import { CiBoxList, CiSearch } from "react-icons/ci";
import { BsGrid } from "react-icons/bs";
import BuyersModal from "./BuyersModal";
import ProductCard from "./ProductCard";
import ProductListTable from "./ProductListTable";
import CategoryCard from "./CategoryCard";
import SubCategoryCard from "./SubCategoryCard";
import SubCategoryProductsView from "./SubCategoryProductsView";
import AddSubCategoryModal from "./AddSubCategoryModal";
import UpdateSubCategoryModal from "./UpdateSubCategoryModal";
import AssignSubCategoryModal from "./AssignSubCategoryModal";
import NavTabs from "./NavTabs";
import PendingProductCard from "./PendingProductCard";
import PendingProductDetails from "./PendingProductDetails";
import { fetchGlobalFeeSettings } from "../../redux/fees/feeSlice";
import {
  approveProduct,
  rejectProduct,
  approveAllProducts,
  createDiscountProductFromExisting,
  getPendingProducts,
  getSubCategories,
  createSubCategory,
  updateSubCategory,
  deleteSubCategory,
  assignProductToSubCategory,
} from "../../redux/thunk";

const DISCOUNT_SHELF_PRODUCT_TYPE_ID = "69de86062800c730ef43b439";

export const Store = () => {
  const adminLevel = sessionStorage.getItem("adminLevel");
  const { token } = useAppSelector((store) => store.auth);
  const [activeTab, setActiveTab] = useState("product");
  const [hasFetchedProducts, setHasFetchedProducts] = useState(false);
  const [hasFetchedDiscountProducts, setHasFetchedDiscountProducts] =
    useState(false);
  const [hasFetchedCategories, setHasFetchedCategories] = useState(false);
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [showUpdateProduct, setShowUpdateProduct] = useState(false);
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [showUpdateCategory, setShowUpdateCategory] = useState(false);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showAddDiscount, setShowAddDiscount] = useState(false);
  const [discountCategory, setDiscountCategory] = useState("");
  const [discountProductId, setDiscountProductId] = useState("");
  const [discountPrice, setDiscountPrice] = useState("");
  const [discountQuantity, setDiscountQuantity] = useState("");
  const [discountMeasurement, setDiscountMeasurement] = useState("");
  const [discountDescription, setDiscountDescription] = useState("");
  const [creatingDiscount, setCreatingDiscount] = useState(false);
  const [searchProducts, setSearchProducts] = useState("");
  const [preview, setPreview] = useState("");
  const [searchResult, setSearchResult] = useState<any[]>([]);
  const [errors, setErrors] = useState<any>({});
  const [filter, setFilter] = useState("");
  const [sortData, setSortData] = useState<products[]>([]);
  const [filterIndicator, setFilterIndicator] = useState(false);
  const [searchIndicator, setSearchIndicator] = useState(false);
  const [feesDetails, setFeesDetails] = useState<any>({});
  const [viewMode, setViewMode] = useState("grid");
  const [filterCategory, setFilterCategory] = useState("");
  const [showLocationsSummary, setShowLocationsSummary] = useState(true);
  const [viewBuyers, setViewBuyers] = useState<{
    modal: boolean;
    data: any[];
  }>({
    modal: false,
    data: [],
  });
  const [selectedPendingProduct, setSelectedPendingProduct] = useState<any>(null);
  const [pendingDetailsProductId, setPendingDetailsProductId] = useState<string | null>(null);
  const [selectedPendingIds, setSelectedPendingIds] = useState<Set<string>>(
    () => new Set(),
  );
  const [approvingAllPending, setApprovingAllPending] = useState(false);
  const [showApproveAllPendingModal, setShowApproveAllPendingModal] =
    useState(false);
  const [statusFilter, setStatusFilter] = useState("all");
  const [pendingPage, setPendingPage] = useState(1);
  const [pendingLimit] = useState(12);

  useEffect(() => {
    if (adminLevel === "superadmin") return;
    if (activeTab !== "pending") return;
    setSelectedPendingProduct(null);
    setPendingDetailsProductId(null);
    setActiveTab("product");
  }, [adminLevel, activeTab]);
  // Free delivery toggle state - track all locations
  const [locationFees, setLocationFees] = useState<any[]>([]);
  const [togglingStates, setTogglingStates] = useState<Record<string, boolean>>(
    {},
  );
  const [isLoading, setIsLoading] = useState({
    updateProd: false,
    deleteProd: false,
    createProd: false,
    createCat: false,
    deleteCat: false,
    updateCat: false,
  });
  const [singleProduct, setSingleProduct] = useState<any>({
    name: "",
    type: "",
    measurement: "",
    quantity: 0,
    lagosPrice: "",
    oyoPrice: "",
    description: "",
    image: "",
  });
  const [categoryDetails, setCategoryDetails] = useState<any>({
    id: "",
    name: "",
    image: "",
  });
  const [categoryUpdateTimestamp, setCategoryUpdateTimestamp] = useState(
    Date.now(),
  );
  const [addCategory, setAddCategory] = useState<any>({
    name: "",
    img: "",
  });
  const [addProduct, setAddProduct] = useState<any>({
    name: "",
    measurement: "",
    image: "",
    type: "",
    productTypeId: "",
    price: [],
    location: [],
    quantity: "",
    description: "",
    lagosSelected: false,
    oyoSelected: false,
    lagosPrice: "",
    oyoPrice: "",
  });

  const dispatch = useAppDispatch();
  const { products, categories, discountProducts, discountStatus, status } =
    useAppSelector(
      (store) => store.products,
    );
  const { pendingProducts: _rawPendingProducts, pendingStatus, pendingPagination } = useAppSelector(
    (store) => store.products,
  );

  const pendingProducts = useMemo(() => {
    if (!Array.isArray(_rawPendingProducts)) return [];
    return _rawPendingProducts.filter(
      (p: any) =>
        p?.status?.toLowerCase() !== "approved" &&
        p?.status?.toLowerCase() !== "rejected"
    );
  }, [_rawPendingProducts]);
  const { subCategories, subCategoriesStatus } = useAppSelector(
    (store) => store.products,
  );

  // ─── Subcategory local state ───
  const [showAddSubCategory, setShowAddSubCategory] = useState(false);
  const [showUpdateSubCategory, setShowUpdateSubCategory] = useState(false);
  const [showAssignSubCategory, setShowAssignSubCategory] = useState(false);
  const [selectedSubCategory, setSelectedSubCategory] = useState<any>(null);
  const [subCatLoading, setSubCatLoading] = useState(false);
  const [subCatFilterCategoryId, setSubCatFilterCategoryId] = useState("");
  const [hasFetchedSubCategories, setHasFetchedSubCategories] = useState(false);
  const [viewingSubCategoryProducts, setViewingSubCategoryProducts] = useState<any>(null);

  const activeProducts =
    activeTab === "discounted" ? discountProducts : products;

  const safeCategories = Array.isArray(categories)
    ? categories
    : Array.isArray((categories as any)?.data)
      ? (categories as any).data
      : [];
  const addProductCategories = safeCategories.filter((category: any) => {
    const categoryId = String(category?._id || category?.id || "").trim();
    return categoryId !== DISCOUNT_SHELF_PRODUCT_TYPE_ID;
  });
  const { globalSettings, vendorSpecificFees } = useAppSelector(
    (store) => store.fees,
  );

  useEffect(() => {
    setHasFetchedProducts(false);
    Promise.resolve(dispatch(getAllProducts()) as any)
      .catch(() => undefined)
      .finally(() => setHasFetchedProducts(true));

    const loadFees = async () => {
      try {
        const action: any = await dispatch(getFees());
        const payload = action?.payload || {};
        const allfees: any[] = payload?.allfees || [];
        setLocationFees(allfees);
      } catch (e) {
        setLocationFees([]);
      }
    };
    loadFees();
    dispatch(fetchGlobalFeeSettings());
    setHasFetchedCategories(false);
    Promise.resolve(dispatch(getAllProductType()) as any)
      .catch(() => undefined)
      .finally(() => setHasFetchedCategories(true));

    // Fetch subcategories on mount
    setHasFetchedSubCategories(false);
    Promise.resolve(dispatch(getSubCategories()) as any)
      .catch(() => undefined)
      .finally(() => setHasFetchedSubCategories(true));
  }, [dispatch]);

  useEffect(() => {
    if (activeTab !== "discounted") return;
    setHasFetchedDiscountProducts(false);
    Promise.resolve(dispatch(getDiscountProducts()) as any)
      .catch(() => undefined)
      .finally(() => setHasFetchedDiscountProducts(true));
  }, [activeTab, dispatch]);

  useEffect(() => {
    if (activeTab !== "pending") return;
    dispatch(getPendingProducts({ page: pendingPage, limit: pendingLimit }));
  }, [activeTab, dispatch, pendingLimit, pendingPage]);

  useEffect(() => {
    if (activeTab !== "pending") return;
    setPendingPage(1);
  }, [activeTab]);

  useEffect(() => {
    // Clear selection when paging/searching between pending lists.
    setSelectedPendingIds(new Set());
  }, [activeTab, pendingPage]);

  useEffect(() => {
    if (!showAddDiscount) return;
    Promise.resolve(dispatch(getAllProductType()) as any).catch(() => undefined);
  }, [dispatch, showAddDiscount]);

  useEffect(() => {
    setSelectedPendingProduct(null);
  }, [activeTab]);

  const handleImageChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    isCategory: boolean,
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      if (isCategory) {
        setCategoryDetails({
          ...categoryDetails,
          image: file,
        });
      } else {
        setSingleProduct({
          ...singleProduct,
          image: file,
        });
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        if (typeof reader.result === "string") {
          setPreview(reader.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleIconClick = () => {
    const fileInput = document.getElementById(
      "fileInput",
    ) as HTMLInputElement | null;
    fileInput?.click();
  };

  const getProductDetails = async (id: any) => {
    try {
      const productResponse = await dispatch(getProduct(id));
      const productData = productResponse.payload;
      setSingleProduct(productData);
      setShowUpdateProduct((prev) => !prev);
    } catch (error: any) {
      console.error("Error fetching product details:", error);
      toast.error(error.message || "An error occured!");
    }
  };

  const handleCategoryClick = (catId: string, name: string, image: string) => {
    setShowUpdateCategory((prev) => !prev);
    setCategoryDetails({
      id: catId,
      name,
      image,
    });
  };

  const handleProductClick = (id: any) => {
    getProductDetails(id);
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setSingleProduct({
      ...singleProduct,
      [name]: value,
    });
  };

  const handleUpdateProduct = async (productId: any) => {
    setIsLoading((prev) => ({ ...prev, updateProd: true }));
    try {
      let imageUrl = singleProduct.image;

      if (singleProduct.image instanceof File) {
        imageUrl = await GetImageURL(singleProduct.image);
      }

      const data = {
        name: singleProduct.name,
        type: singleProduct.type,
        quantity: singleProduct.quantity,
        description: singleProduct.description,
        measurement: singleProduct.measurement,
        price: singleProduct.price,
        image: imageUrl,
      };

      const response = await dispatch(
        updateSingleProduct({ data, id: productId }),
      );

      if (response.payload) {
        toast.success(response.payload.message);
        dispatch(getAllProducts());
        if (pendingDetailsProductId) {
          dispatch(getPendingProducts({ page: pendingPage, limit: pendingLimit }));
          const refreshed: any = await dispatch(getProduct(pendingDetailsProductId));
          if (refreshed?.payload) {
            setSelectedPendingProduct(refreshed.payload);
          }
        }
        setSearchProducts("");
        setSingleProduct({});
        setShowUpdateProduct((prev) => !prev);
        setPendingDetailsProductId(null);
      } else {
        toast.error("Failed to update product");
      }
    } catch (error: any) {
      toast.error(error.message || "An error occurred!");
    } finally {
      setIsLoading((prev) => ({ ...prev, updateProd: false }));
    }
  };

  const handleDeleteProduct = (productId: any) => {
    setIsLoading((prev) => ({ ...prev, deleteProd: true }));
    try {
      dispatch(deleteProduct(productId)).then((response) => {
        setFilter("");
        dispatch(getAllProducts());

        toast.success(
          response.payload.message || "Product deleted successfully!",
        );
        setShowUpdateProduct((prev) => !prev);
      });
    } catch (error: any) {
      toast.error(error.message || "Deletion failed");
    } finally {
      setIsLoading((prev) => ({ ...prev, deleteProd: false }));
    }
  };

  const handleDeleteCategory = (categoryId: string) => {
    setIsLoading((prev) => ({ ...prev, deleteCat: true }));
    try {
      dispatch(deleteProductType(categoryId)).then((response) => {
        dispatch(getAllProductType());
        toast.success(response.payload.message);
        setShowUpdateCategory((prev) => !prev);
      });
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setIsLoading((prev) => ({ ...prev, deleteCat: false }));
    }
  };

  const catFileChange = (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      setAddCategory({
        ...addCategory,
        img: e.target.files[0],
      });
    }
  };

  const productFileChange = (e: any, name: any) => {
    if (name === "image" && e.target.files && e.target.files.length > 0) {
      setAddProduct({
        ...addProduct,
        image: e.target.files[0],
      });
    } else if (name === "lagosPrice" || name === "oyoPrice") {
      const value = e.target.value.trim() === "" ? "" : e.target.value;
      setAddProduct({
        ...addProduct,
        [name]: value,
      });
    } else if (name === "type") {
      const selectedType = e.target.value;
      const matchedType = safeCategories.find(
        (t: any) => t?.type === selectedType,
      );
      setAddProduct({
        ...addProduct,
        type: selectedType,
        productTypeId: matchedType?._id || matchedType?.id || "",
      });
    } else {
      setAddProduct({
        ...addProduct,
        [name]: e.target.value,
      });
    }
  };

  const createCategory = async () => {
    if (addCategoryFormValidation()) {
      toast.error("Please complete the form to add category");
      return;
    }

    const formData = new FormData();
    formData.append("type", addCategory.name);
    formData.append("image", addCategory.img);
    setIsLoading((prev) => ({ ...prev, createCat: true }));

    try {
      dispatch(createProductType(formData)).then(() => {
        dispatch(getAllProductType()).then(() => {
          toast.success("New Category Created!");
          setShowAddCategory((prev) => !prev);
        });
      });
    } catch (error: any) {
      toast.error(error.message || "Category not created!");
    } finally {
      setIsLoading((prev) => ({ ...prev, createCat: false }));
    }
  };

  const handleSearch = (value: string) => {
    if (value.length === 0) {
      setSearchResult([]);
      setFilter("");
    }
    setSearchProducts(value);
    if (value.length > 0) {
      const productData = sortData.length > 0 ? sortData : products;
      const searchedItems = productData.filter((item: any) =>
        item.name.toLowerCase().includes(value.toLowerCase()),
      );
      setSearchResult(searchedItems);
    }
  };

  const GetImageURL = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", "image");

    const uploadUrl =
      process.env.REACT_APP_RESTAURANT_UPLOAD_URL ||
      (process.env.REACT_APP_RESTAURANT_URL
        ? `${process.env.REACT_APP_RESTAURANT_URL.replace(/\/v1\/api\/?$/, "").replace(/\/+$/, "")}/upload/file`
        : "https://api.dev.foodbank4u.com/restaurant/upload/file");

    try {
      const res = await axios.post(uploadUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token,
        },
      });
      return res.data.url;
    } catch (error: any) {
      console.error("Error uploading image:", error);
      throw new Error(error.response?.data?.message || "Image upload failed");
    }
  };

  const createProduct = async () => {
    if (addProductFormValidation()) {
      toast.error("Please complete the form to add product");
      return;
    } else {
      setIsLoading((prev) => ({ ...prev, createProd: true }));
      try {
        const imageUrl = await GetImageURL(addProduct.image);

        const prices: number[] = [];
        const locations: string[] = [];

        if (addProduct.lagosSelected && addProduct.lagosPrice) {
          prices.push(Number(addProduct.lagosPrice));
          locations.push("lagos");
        }

        if (addProduct.oyoSelected && addProduct.oyoPrice) {
          prices.push(Number(addProduct.oyoPrice));
          locations.push("oyo");
        }

        const payload = {
          name: addProduct.name,
          measurement: addProduct.measurement,
          type: addProduct.type,
          productTypeId: addProduct.productTypeId,
          price: prices,
          location: locations,
          quantity: Number(addProduct.quantity),
          image: imageUrl,
          description: addProduct.description,
        };

        const response = await dispatch(createProductItem(payload));

        if ("error" in response) {
          toast.error("Failed to create product");
          return;
        }

        setFilter("");
        await dispatch(getAllProducts());
        await dispatch(getPendingProducts({ page: 1, limit: pendingLimit }));
        toast.success("New Product(s) Created!");
        setShowAddProduct((prev) => !prev);

        setAddProduct({
          name: "",
          measurement: "",
          image: "",
          type: "",
          productTypeId: "",
          price: [],
          location: [],
          quantity: "",
          description: "",
          lagosSelected: false,
          oyoSelected: false,
          lagosPrice: "",
          oyoPrice: "",
        });
      } catch (error: any) {
        toast.error(error.message || "Product not created!");
      } finally {
        setIsLoading((prev) => ({ ...prev, createProd: false }));
      }
    }
  };

  const addProductFormValidation = () => {
    let hasErrors = false;
    const newErrors: any = {};

    if (!addProduct.name) {
      newErrors.productName = "Please enter product name";
      hasErrors = true;
    }
    if (!addProduct.measurement) {
      newErrors.productMeasurement = "Please enter product measurement";
      hasErrors = true;
    }
    if (!addProduct.image) {
      newErrors.productImage = "Please attach product image";
      hasErrors = true;
    }
    if (!addProduct.type) {
      newErrors.productType = "Please select a product category";
      hasErrors = true;
    }
    if (addProduct.type && !addProduct.productTypeId) {
      newErrors.productType = "Please select a valid product category";
      hasErrors = true;
    }

    const hasLagosPrice = addProduct.lagosSelected && addProduct.lagosPrice;
    const hasOyoPrice = addProduct.oyoSelected && addProduct.oyoPrice;

    if (!hasLagosPrice && !hasOyoPrice) {
      newErrors.productPrice =
        "Please select at least one location and enter its price";
      hasErrors = true;
    }

    if (addProduct.lagosSelected && !addProduct.lagosPrice) {
      newErrors.lagosPrice = "Please enter price for Lagos";
      hasErrors = true;
    }

    if (addProduct.oyoSelected && !addProduct.oyoPrice) {
      newErrors.oyoPrice = "Please enter price for Oyo";
      hasErrors = true;
    }

    if (!addProduct.quantity) {
      newErrors.productQuantity = "Please enter product quantity";
      hasErrors = true;
    }
    if (!addProduct.description) {
      newErrors.productDescription = "Please enter product description";
      hasErrors = true;
    }

    setErrors(newErrors);
    return hasErrors;
  };
  const addCategoryFormValidation = () => {
    let hasErrors = false;
    const newErrors: any = {};

    if (!addCategory.name) {
      newErrors.categoryName = "Please enter category name";
      hasErrors = true;
    }
    if (!addCategory.img) {
      newErrors.categoryImage = "Please attach category image";
      hasErrors = true;
    }

    setErrors(newErrors);
    return hasErrors;
  };

  const updateCategory = async (id: string, image: File | string) => {
    if (id) {
      setIsLoading((prev) => ({ ...prev, updateCat: true }));
      try {
        let imageUrl: any = image;

        // If the user selected a new file, we must upload it first to get a URL
        // because the updateProductTypeImage endpoint requires an image URL string.
        if (image instanceof File) {
          imageUrl = await GetImageURL(image);
        }

        if (!imageUrl) {
          toast.error("Failed to process image");
          setIsLoading((prev) => ({ ...prev, updateCat: false }));
          return;
        }

        const response = await dispatch(
          updateProductType({
            id: categoryDetails.id,
            image: imageUrl,
          }),
        );

        setIsLoading((prev) => ({ ...prev, updateCat: false }));
        dispatch(getAllProductType());
        setSearchProducts("");
        toast.success(
          response.payload?.message || "Category updated successfully",
        );
        setCategoryDetails(false);
      } catch (error: any) {
        toast.error(error.message || "Failed to update category");
      } finally {
        setIsLoading((prev) => ({ ...prev, updateCat: false }));
        setShowUpdateCategory((prev) => !prev);
        setCategoryDetails({
          id: "",
          name: "",
          image: "",
        });
      }
    }
  };

  // Function to get product counts by location
  const getLocationCounts = () => {
    if (!activeProducts) return "";

    const counts: Record<string, number> = {};
    activeProducts.forEach((product: any) => {
      const location = product.location?.toLowerCase() || "--";
      counts[location] = (counts[location] || 0) + 1;
    });

    return Object.entries(counts)
      .map(
        ([loc, count]) =>
          `${loc.charAt(0).toUpperCase() + loc.slice(1)}(${count})`,
      )
      .join(" ");
  };

  const [itemsPerPage] = useState(12);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastPost = currentPage * itemsPerPage;
  const indexOfFirstPost = indexOfLastPost - itemsPerPage;

  const getData = () => {
    // Both search and sort data exist
    if (searchProducts.length > 0 && sortData.length > 0) {
      // if filter was last used, filterIndicator is true
      if (filterIndicator) {
        return sortData;
        // if Search bar was last used, filterIndicator is true
      } else if (searchIndicator) {
        return searchResult;
      }
    }
    // Only sort data exists
    else if (sortData.length > 0) {
      return sortData;
    }
    // Only search data exists
    else if (searchProducts.length > 0) {
      return searchResult;
    }
    // Default to original products list
    else {
      return activeProducts;
    }
  };

  const data = getData();

  const currentItems = data?.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.max(1, Math.ceil((data?.length || 0) / itemsPerPage));

  const filterProductsByLocationAndCategory = useCallback(() => {
    if (!filter && !filterCategory) {
      return [];
    }

    const productData = searchResult.length > 0 ? searchResult : activeProducts;
    const filtered = productData.filter((product: any) => {
      const matchesLocation =
        !filter ||
        (filter === "Lagos State" && product.location === "lagos") ||
        (filter === "Oyo State" && product.location === "oyo");

      const matchesCategory =
        !filterCategory || filterCategory === product.type;

      return matchesLocation && matchesCategory;
    });

    return filtered.length > 0 ? filtered : [];
  }, [activeProducts, filter, filterCategory, searchResult]);

  const editServiceOrDeliveryFees = (selectedFee: any) => {
    setFeesDetails(selectedFee);
    setShowServiceModal(true);
  };

  const refreshLocationFees = async () => {
    const action: any = await dispatch(getFees());
    const payload = action?.payload || {};
    const allfees: any[] = payload?.allfees || [];
    setLocationFees(allfees);
  };

  const handleToggleFreeDelivery = async (feeId: string, location: string) => {
    if (!feeId) {
      toast.error("No fee record available to toggle.");
      return;
    }
    setTogglingStates((prev) => ({ ...prev, [feeId]: true }));
    try {
      const result: any = await dispatch(toggleFreeDelivery(feeId));
      if (result?.error) {
        throw new Error(
          result?.payload?.message ||
          result?.error?.message ||
          "Failed to toggle",
        );
      }
      await refreshLocationFees();
      toast.success(`Free delivery setting updated for ${location}.`);
    } catch (err: any) {
      toast.error(err?.message || "Failed to toggle free delivery");
    } finally {
      setTogglingStates((prev) => ({ ...prev, [feeId]: false }));
    }
  };

  const onToggleFreeDeliveryKeyDown = (
    e: any,
    feeId: string,
    location: string,
  ) => {
    if ((e.key === "Enter" || e.key === " ") && !togglingStates[feeId]) {
      e.preventDefault();
      handleToggleFreeDelivery(feeId, location);
    }
  };

  useEffect(() => {
    const filteredProducts = filterProductsByLocationAndCategory();
    setSortData(filteredProducts);
  }, [filter, filterCategory, filterProductsByLocationAndCategory]);

  useEffect(() => {
    if (activeTab !== "product" && activeTab !== "discounted") return;
    setSearchProducts("");
    setSearchResult([]);
    setSortData([]);
    setFilter("");
    setFilterCategory("");
    setFilterIndicator(false);
    setSearchIndicator(false);
    setCurrentPage(1);
  }, [activeTab]);

  const handlePagination = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const prevPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const openApprovalProductDetails = async (product: any) => {
    setSelectedPendingProduct(product);
    const id = String(product?._id || "").trim();
    if (!id) return;
    try {
      const action: any = await dispatch(getProduct(id));
      if (action?.payload) {
        setSelectedPendingProduct((prev: any) => ({
          ...(prev || {}),
          ...(action.payload || {}),
        }));
      }
    } catch {
      // ignore; render best-effort from existing data
    }
  };

  const togglePendingSelection = (id: string) => {
    const nextId = String(id || "").trim();
    if (!nextId) return;
    setSelectedPendingIds((prev) => {
      const next = new Set(prev);
      if (next.has(nextId)) next.delete(nextId);
      else next.add(nextId);
      return next;
    });
  };

  const selectAllPendingOnPage = () => {
    if (!Array.isArray(pendingProducts) || pendingProducts.length === 0) return;
    setSelectedPendingIds((prev) => {
      const idsOnPage = pendingProducts
        .map((p: any) => String(p?._id || "").trim())
        .filter(Boolean);
      const allSelected = idsOnPage.length > 0 && idsOnPage.every((id) => prev.has(id));
      if (allSelected) return new Set();
      return new Set(idsOnPage);
    });
  };

  const handleApproveAllPending = async () => {
    if (approvingAllPending) return;
    const idsFromSelection = Array.from(selectedPendingIds);
    const idsFromPage = Array.isArray(pendingProducts)
      ? pendingProducts
        .map((p: any) => String(p?._id || "").trim())
        .filter(Boolean)
      : [];
    const productIds = (idsFromSelection.length > 0
      ? idsFromSelection
      : idsFromPage
    ).filter(Boolean);

    if (productIds.length === 0) {
      toast.error("No pending products selected.");
      setShowApproveAllPendingModal(false);
      return;
    }

    setApprovingAllPending(true);
    try {
      const res: any = await dispatch(approveAllProducts({ productIds }));
      if (res?.error) {
        toast.error(
          res?.payload || res?.error?.message || "Failed to approve all products",
        );
        return;
      }
      toast.success(res?.payload?.message || "All pending products approved");
      setSelectedPendingIds(new Set());
      dispatch(getPendingProducts({ page: pendingPage, limit: pendingLimit }));
    } finally {
      setApprovingAllPending(false);
      setShowApproveAllPendingModal(false);
    }
  };

  const closeAddDiscountModal = () => {
    setShowAddDiscount(false);
    setDiscountCategory("");
    setDiscountProductId("");
    setDiscountPrice("");
    setDiscountQuantity("");
    setDiscountMeasurement("");
    setDiscountDescription("");
    setCreatingDiscount(false);
  };

  const handleCreateDiscount = async () => {
    const selected: any = Array.isArray(products)
      ? (products as any[]).find((p: any) => p?._id === discountProductId)
      : null;
    const discountPriceValue = Number(discountPrice);
    const discountQuantityValue = Number(discountQuantity);
    const discountMeasurementValue = String(discountMeasurement || "").trim();
    const discountDescriptionValue = String(discountDescription || "").trim();

    if (!discountProductId) {
      toast.error("Please select a product");
      return;
    }
    if (!selected) {
      toast.error("Selected product not found");
      return;
    }
    if (
      !Number.isFinite(discountPriceValue) ||
      discountPriceValue <= 0
    ) {
      toast.error("Please enter a valid discounted price");
      return;
    }

    if (
      !Number.isFinite(discountQuantityValue) ||
      discountQuantityValue <= 0
    ) {
      toast.error("Please enter a valid quantity");
      return;
    }

    if (!discountMeasurementValue) {
      toast.error("Please enter measurement");
      return;
    }

    if (!discountDescriptionValue) {
      toast.error("Please enter description");
      return;
    }

    setCreatingDiscount(true);
    try {
      const res: any = await dispatch(
        createDiscountProductFromExisting({
          existingProductId: String(selected._id || "")
            .trim(),
          productTypeId: String(DISCOUNT_SHELF_PRODUCT_TYPE_ID).trim(),
          discountProductPrice: discountPriceValue,
          quantity: discountQuantityValue,
          measurement: discountMeasurementValue,
          description: discountDescriptionValue,
        }),
      );
      if (res?.error) {
        toast.error(
          res?.payload || res?.error?.message || "Failed to add discount",
        );
        return;
      }
      toast.success(res?.payload?.message || "Discount product created");
      closeAddDiscountModal();
      dispatch(getAllProducts());
      dispatch(getDiscountProducts());
    } finally {
      setCreatingDiscount(false);
    }
  };

  return (
    <>
      <section className="w-full bg-[#F6F4F8]">
        <div className="bg-white w-full rounded-lg p-5 shadow-sm">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
            {/* Primary — Create actions */}
            <div className="flex items-center gap-2">
              <button
                className="inline-flex items-center gap-1.5 rounded-lg px-4 py-2 bg-secondary text-white text-sm font-medium shadow-sm hover:bg-opacity-90 transition-colors"
                onClick={() => setShowAddProduct(true)}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                Product
              </button>
              <button
                className="inline-flex items-center gap-1.5 rounded-lg px-4 py-2 border border-secondary text-secondary text-sm font-medium hover:bg-secondary hover:text-white transition-colors"
                onClick={() => setShowAddCategory(true)}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                Category
              </button>
              <button
                type="button"
                className="inline-flex items-center gap-1.5 rounded-lg px-4 py-2 border border-secondary text-secondary text-sm font-medium hover:bg-secondary hover:text-white transition-colors"
                onClick={() => setShowAddSubCategory(true)}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                Subcategory
              </button>
            </div>

            {/* Divider */}
            <div className="hidden sm:block w-px h-8 bg-gray-200" />

            {/* Secondary — Management actions */}
            <div className="flex items-center gap-2">
              <button
                type="button"
                className="inline-flex items-center gap-1.5 rounded-lg px-4 py-2 bg-gray-100 text-gray-700 text-sm font-medium hover:bg-gray-200 transition-colors"
                onClick={() => setShowAssignSubCategory(true)}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" /></svg>
                Assign Subcategory
              </button>
              <button
                type="button"
                className="inline-flex items-center gap-1.5 rounded-lg px-4 py-2 bg-gray-100 text-gray-700 text-sm font-medium hover:bg-gray-200 transition-colors"
                onClick={() => setShowAddDiscount(true)}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" /></svg>
                Discount Shelf
              </button>
              {adminLevel === "superadmin" && (
                <button
                  type="button"
                  className="inline-flex items-center gap-1.5 rounded-lg px-4 py-2 bg-gray-100 text-gray-700 text-sm font-medium hover:bg-gray-200 transition-colors"
                  onClick={() => setShowServiceModal((prev) => !prev)}
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                  Fees
                </button>
              )}
            </div>
          </div>
        </div>
        <section className="bg-white w-full rounded-sm my-5 py-5 px-2">
          <section className="flex flex-col md:flex-row items-start md:items-end justify-between gap-4">
            <div className="flex flex-wrap items-center gap-4">
              {/* Tabs */}
              <NavTabs
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                products={products}
                discountProducts={discountProducts}
                pendingProducts={pendingProducts}
                categories={categories}
                subCategories={subCategories}
                adminLevel={adminLevel}
              />
            </div>
            {/* Filter */}
            {((activeTab === "product" ||
              activeTab === "discounted" ||
              (activeTab === "pending" && !selectedPendingProduct)) &&
              viewMode === "grid") && (
                <section className="w-64 flex flex-col gap-2">
                  {/* Toggle locations summary */}
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-xs text-gray-600 font-medium">
                      {showLocationsSummary && getLocationCounts()}
                    </span>
                    <button
                      type="button"
                      className="ml-2 p-1 rounded hover:bg-gray-100"
                      onClick={() => setShowLocationsSummary((prev) => !prev)}
                      aria-label="Toggle locations summary"
                    >
                      <IoFilterOutline
                        title="Toggle locations summary"
                        className={`w-5 h-5 text-secondary transition-transform ${showLocationsSummary ? "rotate-90" : ""
                          }`}
                      />
                    </button>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2 text-sm mt-2 md:mt-0">
                      <select
                        name="filter"
                        id="filter"
                        value={filter}
                        onChange={(e) => {
                          setFilterIndicator(true);
                          setSearchIndicator(false);
                          setFilter(e.target.value);
                        }}
                        className="border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-secondary"
                      >
                        <option value="">Locations</option>
                        <option value="Lagos State">Lagos</option>
                        <option value="Oyo State">Oyo</option>
                      </select>
                    </div>
                    <div className="flex items-center gap-2 text-sm mt-2 md:mt-0">
                      <select
                        name="filterCategory"
                        id="filterCategory"
                        value={filterCategory}
                        onChange={(e) => {
                          setFilterIndicator(true);
                          setSearchIndicator(false);
                          setFilterCategory(e.target.value);
                        }}
                        className="border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-secondary"
                      >
                        <option value="">Categories</option>
                        {safeCategories.map((category: any, index: number) => (
                          <option key={index} value={category.type}>
                            {category.type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </section>
              )}
          </section>
          <section>
            <div className="flex justify-between items-center my-6">
              {/* Search */}
              {((activeTab === "product" ||
                activeTab === "discounted" ||
                (activeTab === "pending" && !selectedPendingProduct)) && (
                  <div className="ml-4 w-full max-w-md">
                    <div className="relative">
                      <input
                        type="search"
                        name="search"
                        id="search"
                        value={searchProducts}
                        onChange={(e) => {
                          setFilterIndicator(false);
                          setSearchIndicator(true);
                          handleSearch(e.target.value.trim());
                        }}
                        placeholder="Search products..."
                        className="w-full rounded-lg border border-gray-300 bg-white py-2 pl-10 pr-4 text-sm text-gray-800 shadow-sm focus:border-primary focus:ring-2 focus:ring-secondary outline-none transition"
                      />
                      <CiSearch className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5" />
                    </div>
                  </div>
                ))}

              {/* View toggle */}
              {(activeTab === "product" ||
                activeTab === "discounted" ||
                activeTab === "pending" ||
                activeTab === "uploads") &&
                !selectedPendingProduct && (
                  <div className="flex">
                    <button
                      className={`px-3 py-1 rounded-l flex items-center gap-2 ${viewMode === "grid"
                        ? "bg-secondary text-white"
                        : "bg-gray-100"
                        }`}
                      onClick={() => setViewMode("grid")}
                      type="button"
                      aria-label="Grid view"
                    >
                      <BsGrid className="w-6 h-6" />
                    </button>
                    <button
                      className={`px-3 py-1 rounded-r flex items-center gap-2 ${viewMode === "list"
                        ? "bg-secondary text-white"
                        : "bg-gray-100"
                        }`}
                      onClick={() => setViewMode("list")}
                      type="button"
                      aria-label="List view"
                    >
                      <CiBoxList className="w-6 h-6" />
                    </button>
                  </div>
                )}

              {/* Status Filter for All Uploads */}
              {activeTab === "uploads" && !selectedPendingProduct && (
                <div className="flex items-center gap-2">
                  <div className="relative flex items-center">
                    <div className="absolute left-3 pointer-events-none">
                      <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                      </svg>
                    </div>
                    <select
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                      className="appearance-none bg-white border border-gray-200 rounded-lg pl-10 pr-10 py-2 text-sm font-medium text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-secondary transition-all"
                    >
                      <option value="all">All Statuses</option>
                      <option value="pending">Pending</option>
                      <option value="approved">Approved</option>
                      <option value="rejected">Rejected</option>
                    </select>
                    <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                      <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Products grid or list view */}
            <section
              className={`${(activeTab === "product" && viewMode === "grid") ||
                (activeTab === "discounted" && viewMode === "grid") ||
                activeTab === "category" ||
                ((activeTab === "pending" ||
                  activeTab === "uploads") &&
                  !selectedPendingProduct)
                ? "w-full grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 justify-items-center rounded my-2 gap-5"
                : ""
                }`}
            >
              {(activeTab === "product" || activeTab === "discounted") &&
                ((activeTab === "product" &&
                  (!hasFetchedProducts ||
                    (Array.isArray(products) &&
                      products.length === 0 &&
                      status === "loading"))) ||
                  (activeTab === "discounted" &&
                    (!hasFetchedDiscountProducts ||
                      (Array.isArray(discountProducts) &&
                        discountProducts.length === 0 &&
                        discountStatus === "loading")))) ? (
                <div className="col-span-full w-full flex justify-center py-10">
                  <LoadingSpinner />
                </div>
              ) : activeTab === "category" &&
                (!hasFetchedCategories ||
                  (safeCategories.length === 0 && status === "loading")) ? (
                <div className="col-span-full w-full flex justify-center py-10">
                  <LoadingSpinner />
                </div>
              ) : activeTab === "product" || activeTab === "discounted" ? (
                (filter || filterCategory) && sortData.length === 0 ? (
                  <p className="text-center text-secondary my-10">
                    No products found
                  </p>
                ) : viewMode === "grid" ? (
                  currentItems && currentItems.length > 0 ? (
                    currentItems.map((product: any, index: number) => (
                      <ProductCard
                        key={index}
                        product={product}
                        handleProductClick={handleProductClick}
                      />
                    ))
                  ) : (
                    <p className="text-center text-secondary my-10">
                      No products found
                    </p>
                  )
                ) : (
                  <div className="bg-white rounded-md shadow overflow-hidden w-full">
                    <div className="overflow-x-auto">
                      <ProductListTable
                        currentItems={currentItems}
                        handleProductClick={handleProductClick}
                        setViewBuyers={setViewBuyers}
                        handleDeleteProduct={handleDeleteProduct}
                      />
                    </div>
                  </div>
                )
              ) : activeTab === "pending" ? (
                selectedPendingProduct ? (
                  <div className="w-full">
                    <PendingProductDetails
                      product={selectedPendingProduct}
                      adminLevel={adminLevel}
                      onBack={() => setSelectedPendingProduct(null)}
                      onApprove={async (id) => {
                        const res: any = await dispatch(approveProduct(id));
                        if (res?.error) {
                          toast.error(
                            res?.payload ||
                            res?.error?.message ||
                            "Failed to approve product",
                          );
                          return;
                        }
                        toast.success(
                          res?.payload?.message || "Product approved successfully",
                        );
                        setSelectedPendingProduct(null);
                        dispatch(
                          getPendingProducts({
                            page: pendingPage,
                            limit: pendingLimit,
                          }),
                        );
                      }}
                      onReject={async (id, rejectionReason) => {
                        const res: any = await dispatch(rejectProduct({ productId: id, rejectionReason }));
                        if (res?.error) {
                          toast.error(
                            res?.payload ||
                            res?.error?.message ||
                            "Failed to reject product",
                          );
                          return;
                        }
                        toast.success(
                          res?.payload?.message || "Product rejected successfully",
                        );
                        setSelectedPendingProduct(null);
                        dispatch(
                          getPendingProducts({
                            page: pendingPage,
                            limit: pendingLimit,
                          }),
                        );
                      }}
                      onEdit={(product) => {
                        setSingleProduct(product);
                        setShowUpdateProduct(true);
                        setPendingDetailsProductId(product?._id || null);
                      }}
                    />
                  </div>
                ) : pendingStatus === "loading" ? (
                  <LoadingSpinner />
                ) : Array.isArray(pendingProducts) && pendingProducts.length > 0 ? (
                  <>
                    <div className="col-span-full w-full flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 bg-white border border-gray-100 rounded-md px-4 py-3">
                      <div className="flex items-center gap-3">
                        <button
                          type="button"
                          className="flex items-center gap-2 text-sm text-gray-700"
                          onClick={selectAllPendingOnPage}
                          aria-label="Select all pending products on this page"
                        >
                          <input
                            type="checkbox"
                            className="h-4 w-4 accent-secondary"
                            checked={
                              pendingProducts.length > 0 &&
                              pendingProducts
                                .map((p: any) => String(p?._id || "").trim())
                                .filter(Boolean)
                                .every((id: string) => selectedPendingIds.has(id))
                            }
                            readOnly
                          />
                          <span className="font-medium">Select all (page)</span>
                        </button>
                        <span className="text-xs text-gray-500">
                          {selectedPendingIds.size} selected
                        </span>
                      </div>

                      <div className="flex items-center gap-2">
                        {adminLevel === "superadmin" && (
                          <button
                            type="button"
                            onClick={() => setShowApproveAllPendingModal(true)}
                            disabled={approvingAllPending}
                            className="px-4 py-2 rounded-md text-sm font-medium text-white bg-[#00875A] hover:bg-opacity-90 disabled:opacity-60 disabled:cursor-not-allowed"
                            title="Approve all pending products"
                          >
                            {approvingAllPending ? "Approving..." : "Approve all"}
                          </button>
                        )}
                        <button
                          type="button"
                          onClick={() => setSelectedPendingIds(new Set())}
                          disabled={selectedPendingIds.size === 0}
                          className="px-4 py-2 rounded-md text-sm font-medium border border-gray-200 text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Clear
                        </button>
                      </div>
                    </div>

                    {pendingProducts.map((product: any) => (
                      <PendingProductCard
                        key={product?._id}
                        product={product}
                        onViewDetails={openApprovalProductDetails}
                        selected={selectedPendingIds.has(String(product?._id || "").trim())}
                        onToggleSelect={togglePendingSelection}
                      />
                    ))}

                    {pendingPagination && pendingPagination.totalPages > 1 && (
                      <div className="col-span-full w-full flex items-center justify-between border-t border-gray-100 pt-4 mt-2">
                        <div className="text-sm text-gray-500">
                          Page {pendingPagination.page} of{" "}
                          {pendingPagination.totalPages} •{" "}
                          {pendingPagination.total} total
                        </div>
                        <div className="flex items-center gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              setPendingPage((p) => Math.max(1, p - 1))
                            }
                            disabled={pendingPagination.page <= 1}
                            className="px-4 py-2 border border-gray-200 rounded-md text-sm font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                          >
                            Previous
                          </button>
                          <button
                            type="button"
                            onClick={() =>
                              setPendingPage((p) =>
                                Math.min(pendingPagination.totalPages, p + 1),
                              )
                            }
                            disabled={
                              pendingPagination.page >= pendingPagination.totalPages
                            }
                            className="px-4 py-2 border border-gray-200 rounded-md text-sm font-medium text-gray-800 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <p className="text-center text-secondary my-10">
                    No pending products found
                  </p>
                )
              ) : activeTab === "uploads" ? (
                selectedPendingProduct ? (
                  <div className="w-full">
                    <PendingProductDetails
                      product={selectedPendingProduct}
                      adminLevel={adminLevel}
                      onBack={() => setSelectedPendingProduct(null)}
                      onApprove={async (id) => {
                        const res: any = await dispatch(approveProduct(id));
                        if (res?.error) {
                          toast.error(
                            res?.payload ||
                            res?.error?.message ||
                            "Failed to approve product",
                          );
                          return;
                        }
                        toast.success(
                          res?.payload?.message || "Product approved successfully",
                        );
                        setSelectedPendingProduct(null);
                        dispatch(
                          getPendingProducts({
                            page: pendingPage,
                            limit: pendingLimit,
                          }),
                        );
                      }}
                      onReject={async (id, rejectionReason) => {
                        const res: any = await dispatch(rejectProduct({ productId: id, rejectionReason }));
                        if (res?.error) {
                          toast.error(
                            res?.payload ||
                            res?.error?.message ||
                            "Failed to reject product",
                          );
                          return;
                        }
                        toast.success(
                          res?.payload?.message || "Product rejected successfully",
                        );
                        setSelectedPendingProduct(null);
                        dispatch(
                          getPendingProducts({
                            page: pendingPage,
                            limit: pendingLimit,
                          }),
                        );
                      }}
                      onEdit={(product) => {
                        setSingleProduct(product);
                        setShowUpdateProduct(true);
                        setPendingDetailsProductId(product?._id || null);
                      }}
                    />
                  </div>
                ) : (
                  products
                    .filter(
                      (p: any) => statusFilter === "all" || p.status === statusFilter,
                    )
                    .map((product: any, index: number) => (
                      <PendingProductCard
                        key={product?._id || index}
                        product={product}
                        showStatus={true}
                        onViewDetails={openApprovalProductDetails}
                      />
                    ))
                )
              ) : activeTab === "category" ? (
                safeCategories.length > 0 ? (
                  safeCategories.map((category: any, index: number) => (
                    <CategoryCard
                      key={index}
                      category={category}
                      handleCategoryClick={handleCategoryClick}
                      updateTimestamp={categoryUpdateTimestamp}
                    />
                  ))
                ) : (
                  <p className="text-center text-secondary my-10">
                    No categories found
                  </p>
                )
              ) : activeTab === "subcategory" ? (
                <div className="col-span-full w-full">
                  {viewingSubCategoryProducts ? (
                    (() => {
                      const parentId =
                        typeof viewingSubCategoryProducts.productTypeId === "object"
                          ? viewingSubCategoryProducts.productTypeId?._id
                          : viewingSubCategoryProducts.productTypeId;
                      const parentCat = safeCategories.find(
                        (c: any) => (c._id || c.id) === parentId,
                      );
                      return (
                        <SubCategoryProductsView
                          subCategory={viewingSubCategoryProducts}
                          parentCategoryName={parentCat?.type}
                          onBack={() => setViewingSubCategoryProducts(null)}
                        />
                      );
                    })()
                  ) : (
                    <>
                      {/* Subcategory filter + header */}
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
                        <select
                          value={subCatFilterCategoryId}
                          onChange={(e) => setSubCatFilterCategoryId(e.target.value)}
                          className="border rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-secondary max-w-xs"
                        >
                          <option value="">All Categories</option>
                          {safeCategories.map((cat: any) => (
                            <option key={cat._id || cat.id} value={cat._id || cat.id}>
                              {cat.type}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Subcategory content */}
                      {!hasFetchedSubCategories || subCategoriesStatus === "loading" ? (
                        <div className="flex justify-center py-10">
                          <LoadingSpinner />
                        </div>
                      ) : (() => {
                        const filtered = subCatFilterCategoryId
                          ? subCategories.filter((sc: any) => {
                            const parentId =
                              typeof sc.productTypeId === "object"
                                ? sc.productTypeId?._id
                                : sc.productTypeId;
                            return parentId === subCatFilterCategoryId;
                          })
                          : subCategories;

                        if (filtered.length === 0) {
                          return (
                            <p className="text-center text-secondary my-10">
                              No subcategories found
                            </p>
                          );
                        }

                        return (
                          <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-4">
                            {filtered.map((sub: any) => {
                              const parentId =
                                typeof sub.productTypeId === "object"
                                  ? sub.productTypeId?._id
                                  : sub.productTypeId;
                              const parentCat = safeCategories.find(
                                (c: any) => (c._id || c.id) === parentId,
                              );
                              return (
                                <SubCategoryCard
                                  key={sub._id}
                                  subCategory={sub}
                                  parentCategoryName={parentCat?.type}
                                  onClick={(sc) => {
                                    setSelectedSubCategory(sc);
                                    setShowUpdateSubCategory(true);
                                  }}
                                  onViewProducts={(sc) => setViewingSubCategoryProducts(sc)}
                                />
                              );
                            })}
                          </div>
                        );
                      })()}
                    </>
                  )}
                </div>
              ) : (
                <div className="my-6 flex flex-wrap gap-6">
                  {locationFees && locationFees.length > 0 ? (
                    locationFees.map((fee: any, index: number) => (
                      <div
                        key={fee._id || index}
                        className="bg-gray-50 border border-gray-200 rounded-lg shadow-sm p-5 min-w-[220px] max-w-xs flex flex-col gap-3"
                      >
                        <div className="flex items-center gap-2 mb-2">
                          <span className="font-bold text-lg text-secondary">
                            Location:
                          </span>
                          <span className="font-bold text-lg capitalize">
                            {fee.stateLocation || "--"}
                          </span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="font-semibold text-secondary">
                            Service Fee:
                          </span>
                          <span>
                            ₦{fee.serviceFee?.toLocaleString() || "--"}
                          </span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="font-semibold text-secondary">
                            Delivery Fee:
                          </span>
                          <span>
                            ₦{fee.deliveryFee?.toLocaleString() || "--"}
                          </span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="font-semibold text-secondary">
                            Interest:
                          </span>
                          <span>{fee.interest ?? "--"}%</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="font-semibold text-secondary">
                            Increment:
                          </span>
                          <span>{fee.increment ?? "--"}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="font-semibold text-secondary">
                            Free Delivery on First Order:
                          </span>
                          <button
                            type="button"
                            role="switch"
                            aria-checked={Boolean(
                              fee.isFreeDeliveryOnFirstOrder,
                            )}
                            aria-label={`Toggle free delivery for ${fee.stateLocation}`}
                            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-secondary ${fee.isFreeDeliveryOnFirstOrder
                              ? "bg-green-600"
                              : "bg-gray-300"
                              } ${togglingStates[fee._id]
                                ? "opacity-60 cursor-not-allowed"
                                : "cursor-pointer"
                              }`}
                            onClick={() =>
                              handleToggleFreeDelivery(
                                fee._id,
                                fee.stateLocation,
                              )
                            }
                            onKeyDown={(e) =>
                              onToggleFreeDeliveryKeyDown(
                                e,
                                fee._id,
                                fee.stateLocation,
                              )
                            }
                            disabled={togglingStates[fee._id]}
                            title={`Current: ${fee.isFreeDeliveryOnFirstOrder
                              ? "Enabled"
                              : "Disabled"
                              } (${fee.stateLocation})`}
                          >
                            <span
                              className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${fee.isFreeDeliveryOnFirstOrder
                                ? "translate-x-5"
                                : "translate-x-1"
                                }`}
                            />
                          </button>
                        </div>
                        <button
                          type="button"
                          className="mt-2 px-4 py-1 rounded text-white bg-secondary"
                          onClick={() => editServiceOrDeliveryFees(fee)}
                        >
                          Edit
                        </button>
                      </div>
                    ))
                  ) : (
                    <p className="text-center text-gray-500">
                      No fee information available.
                    </p>
                  )}
                </div>
              )}
            </section>
          </section>
          {activeTab === "product" && (
            <section className="p-3 my-5">
              <Pagination
                length={
                  searchProducts.length > 0
                    ? searchResult.length
                    : sortData.length > 0
                      ? sortData.length
                      : activeProducts.length
                }
                itemsPerPage={itemsPerPage}
                handlePagination={handlePagination}
                currentPage={currentPage}
                prevPage={prevPage}
                nextPage={nextPage}
              />
            </section>
          )}
          {activeTab === "discounted" && (
            <section className="p-3 my-5">
              <Pagination
                length={
                  searchProducts.length > 0
                    ? searchResult.length
                    : sortData.length > 0
                      ? sortData.length
                      : activeProducts.length
                }
                itemsPerPage={itemsPerPage}
                handlePagination={handlePagination}
                currentPage={currentPage}
                prevPage={prevPage}
                nextPage={nextPage}
              />
            </section>
          )}
        </section>
        {showServiceModal && (
          <ServiceModal
            setShowServiceModal={setShowServiceModal}
            feesDetails={feesDetails}
            setFeesDetails={setFeesDetails}
          />
        )}

        {showAddProduct && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-40 text-sm">
            <div className="bg-white p-4 rounded-md" style={{ width: "500px" }}>
              <div className="text-dark p-2 rounded-t-md mb-4">
                <div className="relative w-full">
                  <h2 className="font-bold text-xl">Add Product</h2>
                  <button
                    onClick={() => setShowAddProduct(false)}
                    className="text-dark absolute right-0 top-0"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <form action="" className="text-sm">
                  <div className="flex justify-between items-center my-1">
                    <label htmlFor="name">Product Name:</label>
                    <input
                      className="border p-2 w-2/3"
                      type="text"
                      name="name"
                      id="name"
                      placeholder="Enter product name"
                      onChange={(e) => productFileChange(e, "name")}
                    />
                  </div>
                  {errors.productName && (
                    <span className="text-red-500 text-xs">
                      {errors.productName}
                    </span>
                  )}

                  <div className="flex justify-between items-center my-1">
                    <label htmlFor="type">Category</label>
                    <select
                      name="type"
                      id="type"
                      className="w-2/3 border p-2"
                      value={addProduct.type}
                      onChange={(e) => productFileChange(e, "type")}
                      disabled={!hasFetchedCategories || addProductCategories.length === 0}
                    >
                      {!hasFetchedCategories ? (
                        <option value="">Loading categories...</option>
                      ) : addProductCategories.length === 0 ? (
                        <option value="">No categories available</option>
                      ) : (
                        <option value="">Select product category</option>
                      )}
                      {addProductCategories.map((type: any, index: number) => (
                        <option key={index} value={type.type}>
                          {type.type}
                        </option>
                      ))}
                    </select>
                  </div>

                  {errors.productType && (
                    <span className="text-red-500 text-xs">
                      {errors.productType}
                    </span>
                  )}
                  <div className="flex justify-between items-center my-1 text-sm">
                    <label htmlFor="quantity">Quantity:</label>
                    <input
                      className="border p-2 w-2/3"
                      type="number"
                      name="quantity"
                      id="quantity"
                      placeholder="Enter product quantity"
                      onChange={(e) => productFileChange(e, "quantity")}
                    />
                  </div>
                  {errors.productQuantity && (
                    <span className="text-red-500 text-xs">
                      {errors.productQuantity}
                    </span>
                  )}

                  <div className="flex justify-between items-center my-1">
                    <label htmlFor="measurement">Measurement:</label>
                    <input
                      className="border p-2 w-2/3"
                      type="text"
                      name="measurement"
                      id="measurement"
                      placeholder="Enter product measurement eg. 1kg, 1ltr"
                      onChange={(e) => productFileChange(e, "measurement")}
                    />
                  </div>
                  {errors.productMeasurement && (
                    <span className="text-red-500 text-xs">
                      {errors.productMeasurement}
                    </span>
                  )}
                  <section className="flex justify-between items-center my-1 text-sm">
                    <label htmlFor="price">Selling Price:</label>
                    <section className="flex flex-col w-2/3 gap-2">
                      <div className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          id="lagosSelected"
                          checked={addProduct.lagosSelected}
                          onChange={(e) =>
                            setAddProduct({
                              ...addProduct,
                              lagosSelected: e.target.checked,
                            })
                          }
                        />
                        <label htmlFor="lagosSelected">Lagos</label>
                        <input
                          className={`border p-2 w-[8rem] ${addProduct.lagosSelected ? "" : "bg-gray-100"
                            }`}
                          type="number"
                          name="lagosPrice"
                          id="lagosPrice"
                          placeholder="Price (₦)"
                          value={addProduct.lagosPrice}
                          onChange={(e) => productFileChange(e, "lagosPrice")}
                          disabled={!addProduct.lagosSelected}
                        />
                      </div>
                      {errors.lagosPrice && (
                        <span className="text-red-500 text-xs">
                          {errors.lagosPrice}
                        </span>
                      )}
                      <div className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          id="oyoSelected"
                          checked={addProduct.oyoSelected}
                          onChange={(e) =>
                            setAddProduct({
                              ...addProduct,
                              oyoSelected: e.target.checked,
                            })
                          }
                        />
                        <label htmlFor="oyoSelected">Oyo</label>
                        <input
                          className={`border p-2 w-[8rem] ${addProduct.oyoSelected ? "" : "bg-gray-100"
                            }`}
                          type="number"
                          name="oyoPrice"
                          id="oyoPrice"
                          placeholder="Price (₦)"
                          value={addProduct.oyoPrice}
                          onChange={(e) => productFileChange(e, "oyoPrice")}
                          disabled={!addProduct.oyoSelected}
                        />
                      </div>
                      {errors.oyoPrice && (
                        <span className="text-red-500 text-xs">
                          {errors.oyoPrice}
                        </span>
                      )}
                    </section>
                  </section>
                  {errors.productPrice && (
                    <span className="text-red-500 text-xs">
                      {errors.productPrice}
                    </span>
                  )}

                  <div className="flex justify-between items-center my-1 text-sm">
                    <label htmlFor="image">Add Image:</label>
                    <input
                      type="file"
                      name="image"
                      id="image"
                      onChange={(e) => productFileChange(e, "image")}
                    />
                  </div>
                  {errors.productImage && (
                    <span className="text-red-500 text-xs">
                      {errors.productImage}
                    </span>
                  )}

                  <div className="flex justify-between items-start my-1 text-sm">
                    <label htmlFor="description" className="mt-2">
                      Description:
                    </label>
                    <textarea
                      className="border p-2 w-2/3 resize-none"
                      name="description"
                      id="description"
                      rows={3}
                      placeholder="Enter product description"
                      onChange={(e) => productFileChange(e, "description")}
                    ></textarea>
                  </div>
                  {errors.productDescription && (
                    <span className="text-red-500 text-xs">
                      {errors.productDescription}
                    </span>
                  )}
                </form>
                <div>
                  <button
                    type="button"
                    onClick={createProduct}
                    disabled={
                      isLoading.createProd ||
                      !hasFetchedCategories ||
                      addProductCategories.length === 0
                    }
                    className={`px-5 py-2 mr-3 rounded text-white ${isLoading.createProd ||
                      !hasFetchedCategories ||
                      addProductCategories.length === 0
                      ? "bg-secondary/60 cursor-not-allowed"
                      : "bg-secondary"
                      }`}
                  >
                    {isLoading.createProd ? <Preloader /> : "Add Product"}
                  </button>
                  {!hasFetchedCategories && (
                    <p className="text-xs text-gray-500 mt-2">
                      Loading categories…
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {showUpdateProduct && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-40">
            <div className="bg-white p-4 rounded-md" style={{ width: "500px" }}>
              <div className="  text-dark p-2 rounded-t-md mb-4">
                <div className="relative w-full">
                  <h2 className="font-bold text-xl">Update Product</h2>
                  <button
                    onClick={() => {
                      setShowUpdateProduct((prev) => !prev);
                    }}
                    className="text-dark absolute right-0 top-0"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <form action="">
                  <div className="bg-gray-100 h-24 w-24 shadow relative flex items-center justify-center">
                    <img
                      src={preview || singleProduct.image}
                      alt={singleProduct.name}
                      className="h-24 w-24 object-cover"
                    />
                    <input
                      type="file"
                      id="fileInput"
                      style={{ display: "none" }}
                      onChange={(e) => handleImageChange(e, false)}
                      accept="image/*"
                    />
                    <div
                      className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 cursor-pointer"
                      onClick={handleIconClick}
                    >
                      <FaUpload className="text-white text-xl" />
                    </div>
                  </div>
                  <div className="flex justify-between my-2">
                    <label htmlFor="name">Product Name:</label>
                    <input
                      className="border p-2"
                      type="text"
                      name="name"
                      id="name"
                      value={singleProduct.name}
                      onChange={(e) => handleInputChange(e)}
                    />
                  </div>
                  <div className="flex justify-between my-2">
                    <label htmlFor="type">Category:</label>
                    <select
                      name="type"
                      id="type"
                      className="border p-2 w-2/3"
                      value={singleProduct.type}
                      onChange={(e) => handleInputChange(e)}
                    >
                      <option value="">Select a category</option>
                      {safeCategories.map((cat: any, index: number) => (
                        <option key={index} value={cat.type}>
                          {cat.type}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex justify-between my-2">
                    <label htmlFor="measurement">Measurement:</label>
                    <input
                      className="border p-2 "
                      type="text"
                      name="measurement"
                      id="measurement"
                      value={singleProduct.measurement}
                      onChange={(e) => handleInputChange(e)}
                    />
                  </div>
                  <div className="flex justify-between my-2">
                    <label htmlFor="location">Location:</label>
                    <input
                      className="border p-2 "
                      type="text"
                      name="location"
                      id="location"
                      value={singleProduct.location}
                      onChange={(e) => handleInputChange(e)}
                    />
                  </div>
                  <section className="flex justify-between items-center my-1">
                    <label htmlFor="price">Selling Price:</label>
                    <input
                      className="border p-2 "
                      type="text"
                      name="price"
                      id="price"
                      placeholder="N0.00"
                      value={singleProduct.price ? singleProduct.price : ""}
                      onChange={(e) => handleInputChange(e)}
                    />
                  </section>
                  {errors.productPrice && (
                    <span className="text-red-500 text-xs">
                      {errors.productPrice}
                    </span>
                  )}

                  <div className="flex justify-between my-2">
                    <label htmlFor="quantity">Quantity:</label>
                    <input
                      className="border p-2"
                      type="number"
                      name="quantity"
                      id="quantity"
                      value={singleProduct.quantity}
                      onChange={(e) => handleInputChange(e)}
                    />
                  </div>
                  <div className="flex items-center justify-between my-2">
                    <label htmlFor="description">Description:</label>
                    <textarea
                      className="border p-2"
                      name="description"
                      id="description"
                      value={singleProduct.description}
                      onChange={(e) => handleInputChange(e)}
                      rows={3}
                    />
                  </div>
                </form>
                <div>
                  <button
                    type="button"
                    onClick={() => handleUpdateProduct(singleProduct._id)}
                    className="px-5 py-2 mr-3 rounded text-white bg-secondary"
                  >
                    {isLoading.updateProd ? <Preloader /> : "Update"}
                  </button>
                  <button
                    type="button"
                    onClick={() => handleDeleteProduct(singleProduct._id)}
                    className="px-5 py-2 mr-3 rounded text-white bg-red-500 disabled:bg-red-200 cursor-not-allowed"
                    disabled
                  >
                    {isLoading.deleteProd ? <Preloader /> : "Delete"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {showAddCategory && (
          <AddCategoryModal
            onClose={() => setShowAddCategory(false)}
            onCategoryAdded={() => {
              dispatch(getAllProductType());
              setCategoryUpdateTimestamp(Date.now());
              toast.success("Category Added");
              setShowAddCategory(false);
            }}
          />
        )}
        {showUpdateCategory && (
          <UpdateCategoryModal
            category={categoryDetails}
            onClose={() => setShowUpdateCategory(false)}
            onCategoryUpdated={() => {
              dispatch(getAllProductType());
              setCategoryUpdateTimestamp(Date.now());
              setShowUpdateCategory(false);
            }}
          />
        )}
        {showAddDiscount && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-40 text-sm">
            <div className="bg-white p-4 rounded-md" style={{ width: "500px" }}>
              <div className="text-dark p-2 rounded-t-md mb-4">
                <div className="relative w-full">
                  <h2 className="font-bold text-xl">Discount Shelf</h2>
                  <button
                    type="button"
                    onClick={closeAddDiscountModal}
                    className="text-dark absolute right-0 top-0"
                    aria-label="Close"
                    disabled={creatingDiscount}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleCreateDiscount();
                  }}
                >
                  <div className="flex justify-between items-center my-2">
                    <label htmlFor="discountCategory" className="pr-4">
                      Category:
                    </label>
                    <select
                      id="discountCategory"
                      name="discountCategory"
                      className="border p-2 w-2/3"
                      value={discountCategory}
                      onChange={(e) => {
                        setDiscountCategory(e.target.value);
                        setDiscountProductId("");
                        setDiscountQuantity("");
                        setDiscountMeasurement("");
                        setDiscountDescription("");
                      }}
                      disabled={creatingDiscount}
                    >
                      <option value="">All categories</option>
                      {addProductCategories.map((cat: any, index: number) => (
                        <option key={cat?._id || index} value={cat?.type || ""}>
                          {cat?.type || "--"}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="flex justify-between items-center my-2">
                    <label htmlFor="discountProduct" className="pr-4">
                      Product:
                    </label>
                    <select
                      id="discountProduct"
                      name="discountProduct"
                      className="border p-2 w-2/3"
                      value={discountProductId}
                      onChange={(e) => {
                        const nextId = e.target.value;
                        setDiscountProductId(nextId);
                        const selected: any = Array.isArray(products)
                          ? (products as any[]).find(
                            (p: any) => p?._id === nextId,
                          )
                          : null;
                        setDiscountQuantity(String(selected?.quantity ?? ""));
                        setDiscountMeasurement(
                          String(selected?.measurement ?? "").trim(),
                        );
                        setDiscountDescription(
                          String(selected?.description ?? "").trim(),
                        );
                      }}
                      disabled={creatingDiscount}
                    >
                      <option value="">Select product</option>
                      {Array.isArray(products) &&
                        (products as any[])
                          .filter((p: any) => {
                            if (!discountCategory) return true;
                            return p?.type === discountCategory;
                          })
                          .map((p: any) => (
                            <option key={p?._id} value={p?._id}>
                              {p?.name || "--"}
                              {p?.measurement ? ` (${p.measurement})` : ""}
                            </option>
                          ))}
                    </select>
                  </div>

                  {discountProductId && (
                    <div className="bg-gray-50 border border-gray-200 rounded-md p-3 my-3">
                      {(() => {
                        const selected: any = Array.isArray(products)
                          ? (products as any[]).find(
                            (p: any) => p?._id === discountProductId,
                          )
                          : null;
                        if (!selected) return null;
                        return (
                          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs text-gray-700">
                            <div className="text-gray-500">Name</div>
                            <div className="font-medium text-gray-800">
                              {selected?.name || "--"}
                            </div>
                            <div className="text-gray-500">Measurement</div>
                            <div className="font-medium text-gray-800">
                              {selected?.measurement || "--"}
                            </div>
                            <div className="text-gray-500">Category</div>
                            <div className="font-medium text-gray-800">
                              {selected?.type || "--"}
                            </div>
                            <div className="text-gray-500">Location</div>
                            <div className="font-medium text-gray-800">
                              {selected?.location || "--"}
                            </div>
                            <div className="text-gray-500">Current Price</div>
                            <div className="font-medium text-gray-800">
                              {typeof selected?.price === "number"
                                ? `₦${selected.price.toLocaleString()}`
                                : selected?.price
                                  ? `₦${Number(selected.price).toLocaleString()}`
                                  : "--"}
                            </div>
                            <div className="text-gray-500">Quantity</div>
                            <div className="font-medium text-gray-800">
                              {selected?.quantity ?? "--"}
                            </div>
                          </div>
                        );
                      })()}
                    </div>
                  )}

                  <div className="flex justify-between items-center my-2">
                    <label htmlFor="discountPrice">Discounted Price:</label>
                    <input
                      className="border p-2 w-2/3"
                      type="number"
                      name="discountPrice"
                      id="discountPrice"
                      placeholder="Enter discounted price"
                      value={discountPrice}
                      onChange={(e) => setDiscountPrice(e.target.value)}
                      disabled={creatingDiscount}
                      min={0}
                    />
                  </div>

                  <div className="flex justify-between items-center my-2">
                    <label htmlFor="discountQuantity">Quantity:</label>
                    <input
                      className="border p-2 w-2/3"
                      type="number"
                      name="discountQuantity"
                      id="discountQuantity"
                      placeholder="Enter discount shelf quantity"
                      value={discountQuantity}
                      onChange={(e) => setDiscountQuantity(e.target.value)}
                      disabled={creatingDiscount}
                      min={1}
                    />
                  </div>

                  {/* Measurement field hidden
                  <div className="flex justify-between items-center my-2">
                    <label htmlFor="discountMeasurement">Measurement:</label>
                    <input
                      className="border p-2 w-2/3"
                      type="text"
                      name="discountMeasurement"
                      id="discountMeasurement"
                      placeholder="Enter measurement"
                      value={discountMeasurement}
                      onChange={(e) =>
                        setDiscountMeasurement(e.target.value)
                      }
                      disabled={creatingDiscount}
                    />
                  </div>
                  */}

                  <div className="flex justify-between items-start my-2">
                    <label htmlFor="discountDescription" className="pr-4 pt-2">
                      Description:
                    </label>
                    <textarea
                      className="border p-2 w-2/3 resize-none"
                      name="discountDescription"
                      id="discountDescription"
                      rows={3}
                      placeholder="Enter new description for discount shelf"
                      value={discountDescription}
                      onChange={(e) => setDiscountDescription(e.target.value)}
                      disabled={creatingDiscount}
                    />
                  </div>

                  <div className="mt-4">
                    <button
                      type="submit"
                      className="px-5 py-2 mr-3 rounded text-white bg-secondary disabled:opacity-70 disabled:cursor-not-allowed"
                      disabled={creatingDiscount}
                    >
                      {creatingDiscount ? <Preloader /> : "Add Discount"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
        {viewBuyers.modal && (
          <BuyersModal setViewBuyers={setViewBuyers} data={viewBuyers.data} />
        )}

        {showApproveAllPendingModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50 p-4">
            <div className="w-full max-w-md rounded-lg bg-white p-5 shadow-lg">
              <h3 className="text-lg font-bold text-gray-900">
                Approve all pending products?
              </h3>
              <p className="mt-2 text-sm text-gray-600">
                This will approve every pending product.
              </p>

              <div className="mt-5 flex justify-end gap-2">
                <button
                  type="button"
                  className="px-4 py-2 rounded-md text-sm font-medium border border-gray-200 text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={() => setShowApproveAllPendingModal(false)}
                  disabled={approvingAllPending}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="px-4 py-2 rounded-md text-sm font-medium text-white bg-[#00875A] hover:bg-opacity-90 disabled:opacity-60 disabled:cursor-not-allowed"
                  onClick={handleApproveAllPending}
                  disabled={approvingAllPending}
                >
                  {approvingAllPending ? "Approving..." : "Approve all"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Subcategory Modals ── */}
        {showAddSubCategory && (
          <AddSubCategoryModal
            categories={addProductCategories}
            isLoading={subCatLoading}
            onClose={() => setShowAddSubCategory(false)}
            onSubmit={async (data) => {
              setSubCatLoading(true);
              try {
                const res: any = await dispatch(createSubCategory(data));
                if (res?.error) {
                  toast.error(
                    res?.payload || res?.error?.message || "Failed to create subcategory",
                  );
                  return;
                }
                toast.success(res?.payload?.message || "Subcategory created successfully");
                setShowAddSubCategory(false);
                dispatch(getSubCategories());
              } finally {
                setSubCatLoading(false);
              }
            }}
          />
        )}

        {showUpdateSubCategory && selectedSubCategory && (() => {
          const parentId =
            typeof selectedSubCategory.productTypeId === "object"
              ? selectedSubCategory.productTypeId?._id
              : selectedSubCategory.productTypeId;
          const parentCat = safeCategories.find(
            (c: any) => (c._id || c.id) === parentId,
          );
          return (
            <UpdateSubCategoryModal
              subCategory={selectedSubCategory}
              parentCategoryName={parentCat?.type}
              isLoading={subCatLoading}
              onClose={() => {
                setShowUpdateSubCategory(false);
                setSelectedSubCategory(null);
              }}
              onUpdate={async (id, name) => {
                setSubCatLoading(true);
                try {
                  const res: any = await dispatch(updateSubCategory({ id, name }));
                  if (res?.error) {
                    toast.error(
                      res?.payload || res?.error?.message || "Failed to update subcategory",
                    );
                    return;
                  }
                  toast.success(res?.payload?.message || "Subcategory updated successfully");
                  setShowUpdateSubCategory(false);
                  setSelectedSubCategory(null);
                  dispatch(getSubCategories());
                } finally {
                  setSubCatLoading(false);
                }
              }}
              onDelete={async (id) => {
                setSubCatLoading(true);
                try {
                  const res: any = await dispatch(deleteSubCategory(id));
                  if (res?.error) {
                    toast.error(
                      res?.payload || res?.error?.message || "Failed to delete subcategory",
                    );
                    return;
                  }
                  toast.success(res?.payload?.message || "Subcategory deleted successfully");
                  setShowUpdateSubCategory(false);
                  setSelectedSubCategory(null);
                  dispatch(getSubCategories());
                } finally {
                  setSubCatLoading(false);
                }
              }}
            />
          );
        })()}

        {showAssignSubCategory && (
          <AssignSubCategoryModal
            products={Array.isArray(products) ? products : []}
            subCategories={Array.isArray(subCategories) ? subCategories : []}
            categories={addProductCategories}
            isLoading={subCatLoading}
            onClose={() => setShowAssignSubCategory(false)}
            onAssign={async (assignments) => {
              setSubCatLoading(true);
              try {
                let successCount = 0;
                let failCount = 0;
                for (const item of assignments) {
                  try {
                    const res: any = await dispatch(assignProductToSubCategory(item));
                    if (res?.error) {
                      failCount++;
                    } else {
                      successCount++;
                    }
                  } catch {
                    failCount++;
                  }
                }
                if (successCount > 0) {
                  toast.success(
                    `${successCount} product${successCount !== 1 ? "s" : ""} assigned successfully`,
                  );
                }
                if (failCount > 0) {
                  toast.error(
                    `${failCount} product${failCount !== 1 ? "s" : ""} failed to assign`,
                  );
                }
                setShowAssignSubCategory(false);
                dispatch(getAllProducts());
              } finally {
                setSubCatLoading(false);
              }
            }}
          />
        )}
      </section>
    </>
  );
};
